export default [
  // 领取课程或者票券
  {
    path: '/my',
    name: 'my',
    component: _ => import("@/pages/my/index.vue"),
    meta: {
      title: '我的'
    },
  },
  {
    path: '/my/course',
    name: 'my-course',
    component: _ => import("@/pages/my/course/index.vue"),
    meta: {
      title: '已购'
    },
  },
  {
    path: '/my/order',
    name: 'my-order',
    component: _ => import("@/pages/my/order/index.vue"),
    meta: {
      title: '我的订单'
    },
  },
  {
    path: '/my/ticket',
    name: 'my-ticket',
    component: _ => import("@/pages/my/ticket/index.vue"),
    meta: {
      title: '我的票券'
    },
  },
  {
    path: '/my/ticket-note',
    name: 'my-ticket-note',
    component: _ => import("@/pages/my/ticket/note.vue"),
    meta: {
      title: '上课须知'
    },
  },
  {
    path: '/my/coupons',
    name: 'my-coupons',
    component: _ => import("@/pages/my/coupons/index.vue"),
    meta: {
      title: '优惠券'
    },
  },
  {
    path: '/my/notes',
    name: 'my-notes',
    component: _ => import("@/pages/my/notes/index.vue"),
    meta: {
      title: '优惠券'
    },
  },
  {
    path: '/my/grade',
    name: 'my-grade',
    component: _ => import("@/pages/my/grade/index.vue"),
    meta: {
      title: '学分榜'
    },
  },
  {
    path: '/my/my-grade',
    name: 'my-my-grade',
    component: _ => import("@/pages/my/grade/my-grade.vue"),
    meta: {
      title: '学分明细'
    },
  },
  {
    path: '/my/account',
    name: 'my-account',
    component: _ => import("@/pages/my/account/index.vue"),
    meta: {
      title: '账号设置'
    },
  },
  {
    path: '/my/bind',
    name: 'my-bind',
    component: _ => import("@/pages/my/account/bind.vue"),
    meta: {
      title: '更换手机号'
    },
  },
]